/* This can be imported throughout the app */
export let CONFIG = {};

/* This is called once during application initialization. */
export async function load() {
  let response = await fetch("/api/v1/config");
  let json = await response.json();
  CONFIG = json;
}
